module.exports = __webpack_public_path__ + "img/logo2.0622a982.png";